export default {
    data() {
        return {
            colors: ['default', 'primary', 'info', 'success', 'danger', 'warning'],
        }
    },
    computed: {
        getRandomBackgroundColor() {
            return 'bg-' + this.colors[Math.floor(Math.random() * this.colors.length)]
        },
    },
}
